var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCelebrityGossip = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Movie-Celebrity--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Movie Celebrity Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.87 15.5a1 1 0 0 0 -1.74 1l4 7a1 1 0 0 0 1.74 -1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 15.13a1 1 0 0 0 -1.37 0.37l-4 7a1 1 0 0 0 0.37 1.37 1 1 0 0 0 1.37 -0.37l4 -7a1 1 0 0 0 -0.37 -1.37Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 4.5a0.76 0.76 0 0 0 -0.75 0.75v1.5a0.75 0.75 0 0 0 1.5 0v-1.5a0.76 0.76 0 0 0 -0.75 -0.75Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.75A0.76 0.76 0 0 0 6.75 3h-1.5a0.75 0.75 0 0 0 0 1.5h1.5a0.76 0.76 0 0 0 0.75 -0.75Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 3a0.76 0.76 0 0 0 0.75 -0.75V0.75a0.75 0.75 0 0 0 -1.5 0v1.5a0.76 0.76 0 0 0 0.75 0.75Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 4.5h1.5a0.75 0.75 0 0 0 0 -1.5H0.75a0.75 0.75 0 0 0 0 1.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.25 9.5a0.76 0.76 0 0 0 -0.75 0.75v1.5a0.75 0.75 0 0 0 1.5 0v-1.5a0.76 0.76 0 0 0 -0.75 -0.75Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.75 9.5h1.5a0.75 0.75 0 0 0 0 -1.5h-1.5a0.75 0.75 0 0 0 0 1.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.25 8a0.76 0.76 0 0 0 0.75 -0.75v-1.5a0.75 0.75 0 0 0 -1.5 0v1.5a0.76 0.76 0 0 0 0.75 0.75Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 8.75a0.76 0.76 0 0 0 -0.75 -0.75h-1.5a0.75 0.75 0 0 0 0 1.5h1.5a0.76 0.76 0 0 0 0.75 -0.75Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3 9.35a0.27 0.27 0 0 1 -0.12 -0.22 0.23 0.23 0 0 1 0.11 -0.21 4.07 4.07 0 1 0 -4.41 -0.09 0.26 0.26 0 0 1 0.11 0.23 0.26 0.26 0 0 1 -0.14 0.2 4.8 4.8 0 0 0 -2.62 4.27v2.85a0.5 0.5 0 0 0 0.14 0.35 0.49 0.49 0 0 0 0.36 0.15H9a0.51 0.51 0 0 1 0.5 0.45l0.62 6.22a0.49 0.49 0 0 0 0.5 0.45h2.84a0.49 0.49 0 0 0 0.5 -0.45l0.62 -6.22a0.51 0.51 0 0 1 0.5 -0.45h1.23a0.49 0.49 0 0 0 0.36 -0.15 0.5 0.5 0 0 0 0.14 -0.35v-2.85a4.75 4.75 0 0 0 -2.51 -4.18Zm-1.55 3.37a0.75 0.75 0 0 1 -1.5 0V11a0.75 0.75 0 0 1 1.5 0Zm-0.6 -5.19a2.08 2.08 0 0 1 -2.07 -2.08 2.35 2.35 0 0 1 0.08 -0.6 0.29 0.29 0 0 1 0.15 -0.16 0.28 0.28 0 0 1 0.22 0 5.08 5.08 0 0 0 2.65 0.74 6.3 6.3 0 0 0 0.75 0 0.23 0.23 0 0 1 0.21 0.06 0.27 0.27 0 0 1 0.07 0.21 2.07 2.07 0 0 1 -2.06 1.83Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCelebrityGossip);
export default ForwardRef;